import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { SalesPage } from './pages/SalesPage';
function App() {
  return <LanguageProvider data-id="element-0">
      <SalesPage data-id="element-1" />
    </LanguageProvider>;
}
export { App };